<section class="configuration-workspace">
  @if (loading) {
    <div class="configuration-loading"><span class="spinner-border"></span></div>
  }
  @if (error) {
    <div class="alert alert-danger">{{ error | translate }}</div>
  }
  @if (saved) {
    <div class="alert alert-success">{{ 'CONFIGURATION_SAVED' | translate }}</div>
  }

  @if (jeeves) {
    <div class="configuration-heading">
      <div>
        <span class="eyebrow">Jeeves ERP</span>
        <h2>{{ 'JEEVES_FINANCE_CONFIGURATION' | translate }}</h2>
        <p>{{ 'JEEVES_RULES_HELP' | translate }}</p>
      </div>
      <div class="configuration-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="validate()">
          <i class="fa-solid fa-shield-check"></i> {{ 'VALIDATE' | translate }}</button
        ><button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">
          <span *ngIf="saving" class="spinner-border spinner-border-sm"></span> {{ 'SAVE_CONFIGURATION' | translate }}
        </button>
      </div>
    </div>

    <div class="configuration-grid">
      <div class="configuration-main">
        <article class="config-card">
          <header>
            <i class="fa-solid fa-building-columns"></i>
            <div>
              <h3>{{ 'JEEVES_RULES' | translate }}</h3>
              <p>{{ 'JEEVES_RULES_HELP' | translate }}</p>
            </div>
          </header>
          <div class="field-grid">
            <label
              ><span>{{ 'DEFAULT_WAREHOUSE' | translate }}</span
              ><input class="form-control" type="number" min="1" [(ngModel)]="jeeves.defaultWarehouse"
            /></label>
          </div>
          <div class="map-grid map-grid--two">
            <label
              ><span>{{ 'COUNTRY_VAT_TO_TAX_CODE' | translate }}</span
              ><small>SE&#64;25 = 1</small
              ><textarea
                class="form-control code-input"
                rows="8"
                [(ngModel)]="mapText.countryAndTaxPercentToTaxCode"
              ></textarea>
            </label>
            <label
              ><span>{{ 'MARKETPLACE_TO_WAREHOUSE' | translate }}</span
              ><small>Amazon.se = 10</small
              ><textarea
                class="form-control code-input"
                rows="8"
                [(ngModel)]="mapText.marketplaceToWarehouse"
              ></textarea>
            </label>
          </div>
        </article>
      </div>

      <aside class="configuration-side">
        <article class="config-card validation-card">
          <header>
            <i class="fa-solid fa-stethoscope"></i>
            <div>
              <h3>{{ 'CONFIGURATION_HEALTH' | translate }}</h3>
              <p>{{ 'LIVE_VALIDATION_RESULTS' | translate }}</p>
            </div>
          </header>
          <div class="health-section">
            <strong>Jeeves</strong>
            @if (!validation?.errors?.length && !validation?.warnings?.length) {
              <p class="health-ok"><i class="fa-solid fa-circle-check"></i> {{ 'VALID_CONFIGURATION' | translate }}</p>
            }
            @for (message of validation?.errors || []; track message) {
              <p class="health-error"><i class="fa-solid fa-circle-xmark"></i> {{ message }}</p>
            }
            @for (message of validation?.warnings || []; track message) {
              <p class="health-warning"><i class="fa-solid fa-triangle-exclamation"></i> {{ message }}</p>
            }
          </div>
          <div class="health-section">
            <div class="health-title">
              <strong>{{ 'ERP_REFERENCES' | translate }}</strong
              ><button type="button" class="btn btn-sm btn-link" (click)="refreshReferenceValidation()">
                <i class="fa-solid fa-rotate"></i>
              </button>
            </div>
            @if (
              referenceValidation &&
              !referenceValidation.missingCustomerIds.length &&
              !referenceValidation.missingProductIds.length
            ) {
              <p class="health-ok"><i class="fa-solid fa-circle-check"></i> {{ 'ALL_REFERENCES_EXIST' | translate }}</p>
            }
            @if (referenceValidation?.missingCustomerIds?.length) {
              <p class="health-error">
                {{ 'MISSING_CUSTOMERS' | translate }}: {{ referenceValidation.missingCustomerIds.join(', ') }}
              </p>
            }
            @if (referenceValidation?.missingProductIds?.length) {
              <p class="health-error">
                {{ 'MISSING_PRODUCTS' | translate }}: {{ referenceValidation.missingProductIds.join(', ') }}
              </p>
            }
          </div>
        </article>

        <article class="config-card reference-card">
          <header>
            <i class="fa-solid fa-magnifying-glass"></i>
            <div>
              <h3>{{ 'JEEVES_REFERENCE_LOOKUP' | translate }}</h3>
              <p>{{ 'REFERENCE_LOOKUP_HELP' | translate }}</p>
            </div>
          </header>
          <div class="reference-controls">
            <select class="form-select" [(ngModel)]="referenceType">
              <option value="customers">{{ 'CUSTOMERS' | translate }}</option>
              <option value="products">{{ 'PRODUCTS' | translate }}</option>
            </select>
            <div class="input-group">
              <input class="form-control" [(ngModel)]="referenceQuery" (keyup.enter)="searchReferences()" /><button
                class="btn btn-outline-primary"
                type="button"
                (click)="searchReferences()"
                [disabled]="searching"
              >
                <i class="fa-solid fa-search"></i>
              </button>
            </div>
          </div>
          <div class="reference-results">
            @for (reference of references; track reference.id) {
              <div>
                <code>{{ reference.id }}</code
                ><span>{{ reference.label }}</span>
              </div>
            }
            @if (!references.length) {
              <p>{{ 'SEARCH_FOR_REFERENCE' | translate }}</p>
            }
          </div>
        </article>
      </aside>
    </div>

    <div class="sticky-save">
      <span>{{ 'CONFIGURATION_AUDITED' | translate }}</span>
      <div>
        <button type="button" class="btn btn-outline-secondary" (click)="validate()">
          {{ 'VALIDATE' | translate }}</button
        ><button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">
          {{ 'SAVE_CONFIGURATION' | translate }}
        </button>
      </div>
    </div>
  }
</section>
